import React from "react";
import styles from "./style/answer_likert.module.css";
import ImgBuilder from "../../assets/ImgBuilder";
import { useLanguage } from '../../functions/setGetLanguage';

import ButtonLikert from "../buttonLikert/buttonLikert";

const Answer_likert = ({ choices, likertType, FunctionOnClick}) => {
  const { language } = useLanguage();
  const likertMap = Object.fromEntries(choices.map(item => [item.likert, item]));

  const likertImages = {"time": {
    1: ImgBuilder.never,
    2: ImgBuilder.almostNever,
    3: ImgBuilder.sometimes,
    4: ImgBuilder.almostAlways,
    5: ImgBuilder.always,
  }, "not-time": {
    1: ImgBuilder.s_disagree,
    2: ImgBuilder.disagree,
    3: ImgBuilder.neutral,
    4: ImgBuilder.agree,
    5: ImgBuilder.s_agree,
  },default: {
    1: ImgBuilder.s_disagree,
    2: ImgBuilder.disagree,
    3: ImgBuilder.neutral,
    4: ImgBuilder.agree,
    5: ImgBuilder.s_agree,
  }};

  const selectedLikert = likertImages[likertType] || likertImages.default;

  return (
    <div className={styles.choices}>
      <div className={styles.upperChoices}>
      
        {Object.entries(likertMap).slice(0, -1).map(([k, v], idx) =>
          <ButtonLikert
            key={idx}
            img={selectedLikert[k]}
            info={v}
            likertKey={k}
            FunctionOnClick={FunctionOnClick}
          />
        )}

      </div>
      <div className={styles.lowerChoices}>
        <button onClick={() => FunctionOnClick(likertMap[999])} className={styles.prefernotButton}>{likertMap[999][`text${language}`]}</button>
      </div>
    </div>
  );
};

export default Answer_likert;
